import { defineStore } from "pinia";

export const useIdleStore = defineStore("idle", {
  state: () => ({
    showIdleWarning: false,
  }),
});
